<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Productos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div>
                  <router-link
                    class="btn btn-sm btn-success"
                    :to="{ name: 'cat-productos-nuevo', params: {} }"
                  >
                    <i class="fa fa-pencil"></i>
                    Nuevo Producto
                  </router-link>
                </div>
                <div class="col-3">
                  <input
                    class="form-control form-control-sm rounded bright"
                    placeholder="Search"
                    v-model="filter.searchtext"
                    type="text"
                    v-on:keyup.enter="filterData()"
                  />
                </div>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" @click="filterData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <a
                  v-if="mostrarRefresh"
                  class="btn btn-sm btn-info"
                  @click="refreshData"
                  href="#"
                  >Refresh</a
                >
              </div>
            </div>
            <div class="col-sm-12">
              <form class="form-inline justify-content-sm-end" @submit="filterDataSubmit">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Código Original"
                  v-model="filter.codigo_original"
                  type="text"
                  style="width: 11%"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Código Fabricante"
                  v-model="filter.codigo_fabricante"
                  type="text"
                  style="width: 11%"
                />
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Sku"
                  v-model="filter.sku"
                  type="text"
                  style="width: 9%"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  v-model="filter.activo"
                  class="form-control form-control-sm rounded bright"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="false">Inactivos</option>
                  <option value="true">Activos</option>
                </select>
              </form>
            </div>            
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Nombre</th>
                <th class="text-center">Venta</th>
                <th class="text-center">Compra</th>
                <th class="text-center">Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.sku }}</td>
                <td>{{ current.nombre }}</td>
                <td class="text-center">
                  <div
                    v-if="current.permitir_venta"
                    class="status-pill green"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.permitir_venta"
                    class="status-pill red"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td class="text-center">
                  <div
                    v-if="current.permitir_compra"
                    class="status-pill green"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.permitir_compra"
                    class="status-pill red"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td class="text-center">
                  <div
                    v-if="current.activo"
                    class="status-pill green"
                    data-title="Activo"
                    data-toggle="tooltip"
                  ></div>
                  <div
                    v-if="!current.activo"
                    class="status-pill red"
                    data-title="Inactivo"
                    data-toggle="tooltip"
                  ></div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import UsuariosService from "@/services/accounts/UsuariosService.js";
import DynamicService from "../../../services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      permisos: [],
      searchtext: "",
      filter: {},
      data: [],
    };
  },
  mounted() {
    this.refreshData();
    this.redirect();
    UsuariosService.profile().then((response) => {
      this.permisos = response.data.permisos;
    });
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        if (self.permisos.includes("catalogos.change_producto")) {
          let routeUrl = this.$router.resolve({
            name: "cat-productos-editar",
            params: { sku: current.sku },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          let routeUrl = this.$router.resolve({
            name: "cat-consulta-productos",
            params: { sku: current.sku },
          });
          window.open(routeUrl.href, "_blank");
        }
      } else {
        if (self.permisos.includes("catalogos.change_producto")) {
          self.$router.push({
            name: "cat-productos-editar",
            params: { sku: current.sku },
          });
        } else {
          self.$router.push({
            name: "cat-consulta-productos",
            params: { sku: current.sku },
          });
        }
      }
    },
    redirect() {
      let self = this;
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          if (response.data.count > 0) {
            self.$router.push({ path: "/cat/consulta-productos/" });
          }
        })
        .catch((error) => {});
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.filter.searchtext,
        activo: this.filter.activo,
        codigo_original: this.filter.codigo_original,
        codigo_fabricante: this.filter.codigo_fabricante,
        sku: this.filter.sku,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.filter.searchtext,
        activo: this.filter.activo,
        codigo_original: this.filter.codigo_original,
        codigo_fabricante: this.filter.codigo_fabricante,
        sku: this.filter.sku,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.filter.activo = "";
      this.filter.codigo_original = "";
      this.filter.codigo_fabricante = "";
      this.filter.sku = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ProductosService.fetch(params).then((res) => {
        self.data = res.data;        
      });
    },
    showModalEdit() {},
  },
};
</script>
